/**
 * Shared first-time elder profile inputs (name + time zone). Used by
 * SetupDevice (combined with claim) and Welcome (first sign-in
 * without a setup code). Single source of truth for the field copy
 * and the timezone list.
 */

import { Field } from '@/components/ui/Field';
import { Input } from '@/components/ui/Input';
import { timeZoneOptions } from '@/lib/timeZone';

interface Props {
  elderName: string;
  onElderNameChange: (v: string) => void;
  timeZone: string;
  onTimeZoneChange: (v: string) => void;
}

export function ElderProfileFields({
  elderName,
  onElderNameChange,
  timeZone,
  onTimeZoneChange,
}: Props) {
  return (
    <>
      <Field label="First name of the person you care for" htmlFor="elderName">
        <Input
          id="elderName"
          value={elderName}
          onChange={(e) => onElderNameChange(e.target.value)}
          required
          maxLength={100}
          placeholder="First name"
        />
      </Field>
      <Field label="Time zone" htmlFor="timeZone">
        <select
          id="timeZone"
          className="h-10 w-full rounded-lg border border-paper-border bg-white px-3 text-sm text-ink"
          value={timeZone}
          onChange={(e) => onTimeZoneChange(e.target.value)}
        >
          {timeZoneOptions(timeZone).map((tz) => (
            <option key={tz.value} value={tz.value}>
              {tz.label}
            </option>
          ))}
        </select>
      </Field>
    </>
  );
}
